module.exports = __webpack_public_path__ + "img/TECHNOLOGY-FRONX-BOOSTERGREEN-3.3eac5eeb.jpg";